import { get } from "react-hook-form";
import { getForms } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/formsContext";
import { useEffect, useState } from "react";

export const useSearchData = () => {
	const {
		state: { dataToGetFormInstances },
		actions: { setRows, setRowData, setAllRowsLoading },
	} = useFormsContext();

	const [startLodingRows, setStartLodingRows] = useState(false);

	useEffect(() => {
		if (!startLodingRows) {
			setAllRowsLoading(false);
		}
	}, [startLodingRows]);

	return async () => {
		setRows([]);
		setAllRowsLoading(true);
		setStartLodingRows(true);
		const { Start, End, AssetId, FormId, SearchText, FormInstanceStatusCode } =
			dataToGetFormInstances;

		return getForms(
			Start,
			End,
			AssetId,
			FormId,
			SearchText,
			FormInstanceStatusCode,
		).then((res) => {
			if (res.ok) {
				const rowsSource = get(res, "data", null);
				const dataTable = rowsSource.tables[0];
				setRows(dataTable.rows);
				setRowData(dataTable.rows);
				setStartLodingRows(false);
			}
			return res;
		});
	};
};
